import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-getjob',
  templateUrl: './getjob.component.html',
  styleUrls: ['./getjob.component.css']
})
export class GetjobComponent implements OnInit {

  copyButton: boolean = true;
  copiedButton: boolean = false;

  exampleRequest: string;

  constructor(private sanitizer: DomSanitizer) { 

    this.exampleRequest = `  curl -v 'https://api.optimusdrive.ai/vod/v1/video/job/<job_id>' \ -H 'authorization: XXX'
  

    `;
  }

  ngOnInit(): void {
  }


  Error502 = `
  {
    "message": "Internal server error"
  }
  `

  copyToClipBoard(url: string) {
    var txtArea = document.createElement('textarea');
    txtArea.id = 'txt';
    txtArea.style.position = 'fixed';
    txtArea.style.top = '0';
    txtArea.style.left = '0';
    txtArea.style.opacity = '0';
    txtArea.value = url;
    document.body.appendChild(txtArea);
    txtArea.select();

    try {
      var successful = document.execCommand('copy');
      if (successful) {
        this.copyButton = false;
        this.copiedButton = true;
        // After a few seconds, reset the button states
        setTimeout(() => {
          this.copyButton = true;
          this.copiedButton = false;
        }, 1000);
      }
    } catch (err) {
    } finally {
      document.body.removeChild(txtArea);
    }
  }

  copyJsonToClipboard() {
    this.copyToClipBoard(this.exampleRequest);
  }


  sucessData = `
  {
    "data": {
      "id": "409cdc3b-c216-47a8-a684-ecbd351528ff",
      "created_at": 1690449866,
      "updated_at": 1690450019,
      "processing_time": 147,
      "transcoding_time": 7,
      "preprocessing_time": 1,
      "input_info": {
        "resolution": "1920 X 1080 pixels",
        "class_label": "FullHD",
        "frame_rate": "29.970 fps",
        "bit_rate": "17516070 b/s",
        "file_size": 21916983,
        "filename": "Show.MOV",
        "duration": 10,
        "height": 1080,
        "width": 1920
      },
      "output_info": {
        "variants": [
          {
            "name": "Show",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/mp4/TP1H264/Show.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/Show.jpeg",
            "resolution": "1920 X 1080 pixels",
            "class_label": "FullHD",
            "frame_rate": "24.802 fps",
            "bit_rate": "2064637 b/s",
            "file_size": 2752371,
            "height": 1080,
            "width": 1920
          },
          {
            "name": "Show",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/mp4/video4/Show.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/Show.jpeg",
            "resolution": "1280 X 720 pixels",
            "class_label": "HD",
            "frame_rate": "24.802 fps",
            "bit_rate": "1205129 b/s",
            "file_size": 1665083,
            "height": 720,
            "width": 1280
          },
          {
            "name": "Show",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/mp4/video5/Show.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/Show.jpeg",
            "resolution": "854 X 480 pixels",
            "class_label": "SD",
            "frame_rate": "24.802 fps",
            "bit_rate": "711540 b/s",
            "file_size": 1040689,
            "height": 480,
            "width": 854
          },
          {
            "name": "Show",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/mp4/video6/Show.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/Show.jpeg",
            "resolution": "640 X 360 pixels",
            "class_label": "SD",
            "frame_rate": "24.802 fps",
            "bit_rate": "424134 b/s",
            "file_size": 677111,
            "height": 360,
            "width": 640
          },
          {
            "name": "Show",
            "output_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/mp4/video7/Show.mp4",
            "thumbnail_url": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/Show.jpeg",
            "resolution": "480 X 270 pixels",
            "class_label": "SD",
            "frame_rate": "25.000 fps",
            "bit_rate": "250000 b/s",
            "file_size": 441488,
            "height": 270,
            "width": 480
          }
        ],
        "hls_manifest": "https://optimus-media.crunchmediaworks.com/vod/409cdc3b-c216-47a8-a684-ecbd351528ff/hls/master.m3u8"
      },
      "source": "oci",
      "source_path": "VideoForOptimizer/Show.MOV",
      "crunch_mode": "optimizer",
      "status": "COMPLETED",
      "output_video_codec": "h264",
      "abr_type": "HLS_MP4",
      "status_history": [
        {
          "status": "PENDING",
          "event_time": 1690449866
        },
        {
          "status": "PREPROCESSING",
          "event_time": 1690449868
        },
        {
          "status": "TRANSCODING",
          "event_time": 1690450008
        },
        {
          "status": "POSTPROCESSING",
          "event_time": 1690450020
        },
        {
          "status": "COMPLETED",
          "event_time": 1690450020
        }
      ]
    },
    "message": "Job details fetched successfully"
  }
  `


  Error5x = `
  {
    "error":"No job details found with this id",
    "message":"Error while fetching the job details"
  }`






}
